import getFormError from '../utils/getFieldError';
import { connect } from 'formik';

const ErrorMessage = ({ name, formik }) => {
    return getFormError(formik, name);
};

export default connect(ErrorMessage);
